import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import MerchantLayout from "@/components/MerchantLayout";
import { mApi } from "@/lib/api";

export default function MerchantWebhooks() {
  const [me, setMe] = useState(null);
  const [url, setUrl] = useState("");

  useEffect(() => {
    mApi.get("/merchant/me").then((r) => {
      setMe(r.data);
      setUrl(r.data?.merchant?.webhook_url || "");
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await mApi.post("/merchant/webhooks/register", { url, events: ["card.*", "transaction.*"] });
      toast.success("Webhook registered");
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  return (
    <MerchantLayout>
      <div className="p-4 sm:p-6 lg:p-10" data-testid="m-webhooks-page">
        <h1 className="font-display text-3xl tracking-tight font-medium mb-1">Webhooks</h1>
        <p className="text-sm text-zinc-500 mb-6">Receive Blonix events on your endpoint. Use your webhook signing secret to verify deliveries.</p>

        <div className="bg-white border border-zinc-200 rounded-sm p-6 max-w-2xl">
          <form onSubmit={save} className="space-y-4">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-700 mb-1.5">Endpoint URL</label>
              <input
                value={url} onChange={(e) => setUrl(e.target.value)}
                data-testid="webhook-url-input"
                placeholder="https://yourapp.com/blonix/webhooks"
                className="w-full h-10 px-3 text-sm bg-white border border-zinc-200 rounded-sm focus:ring-1 focus:ring-zinc-900 focus:border-zinc-900 outline-none font-mono"
              />
            </div>
            <button data-testid="webhook-save-btn" className="h-9 px-4 text-sm bg-zinc-950 text-white rounded-sm hover:bg-zinc-800 transition-colors duration-150">Save endpoint</button>
          </form>
        </div>

        <div className="mt-6 bg-white border border-zinc-200 rounded-sm p-6 max-w-2xl">
          <div className="font-display text-lg tracking-tight font-medium mb-2">Verification</div>
          <p className="text-sm text-zinc-600 mb-3">Each request includes signing headers. Verify with your webhook signing secret.</p>
          <pre className="bg-zinc-950 text-emerald-200 font-mono text-[11px] p-4 rounded-sm overflow-x-auto">
{`X-Timestamp: 1759782345
X-Signature: <hex(HMAC-SHA256(secret, "ts\\nmethod\\npath\\nbody"))>
X-Blonix-Event: card.created
X-Blonix-Event-Id: <uuid>
Content-Type: application/json`}
          </pre>
        </div>
      </div>
    </MerchantLayout>
  );
}
